import { useState, useCallback } from 'react'
import { API, API_ROUTER } from '../../../../../api'

const useGetAuthCommunity = () => {
  const [communityList, setCommunityList] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const getAuthCommunity = useCallback((page = 1, filters = {}) => {
    setIsLoading(true)
    let urlParams = {}

    if (filters.allowIsPro !== undefined) {
      urlParams['allowIsPro'] = filters.allowIsPro
    }

    API.request({
      ...API_ROUTER.community.getAuthCommunityList,
      urlParams,
      pathKeys: {
        page,
        limit: 10,
      },
    })
      .then(res => {
        setCommunityList(res)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }, [])

  return { communityList, isLoading, getAuthCommunity }
}

export default useGetAuthCommunity
